import { createSlice } from '@reduxjs/toolkit';
import { clinicInformation, personalInformation } from '../../Schema';
const initialState = {
  data: {
    password: '',
    title: '',
    fullName: '',
    dateOfBirth: '',
    secondaryCountryCode: '',
    secondaryCellNumber: '',
    gender: null,
    clinicName: '',
    clinicAddress: '',
    clinicState: null,
    clinicCity: null,
    speciality: '',
    feeAmount: 0,
    pinCode: '',
    confirmPinCode: ''
  },
  verifiedPage: {
    pinCode: false,
    personalInformation: false,
    clinicInformation: false
  }
};
const signupStepPageSlice = createSlice({
  name: 'authSlice',
  initialState,
  //   reducer needs a map
  reducers: {
    setSignupFormData(state, action) {
      state.data = {
        ...state.data,
        ...action.payload
      };
    },

    setVerifiedPage(state, action) {
      state.verifiedPage = {
        ...state.verifiedPage,
        ...action.payload
      };
    }
  }
});
export const { setSignupFormData, setVerifiedPage } = signupStepPageSlice.actions;
export default signupStepPageSlice.reducer;
